/* eslint-disable react-hooks/exhaustive-deps */
import { useIsFocused, useNavigation } from "@react-navigation/native";

import React, { useCallback, useEffect, useMemo, useState } from "react";

import Image from "@components/common/Image";
import Text from "@components/CustomText";
import OrderCancelReasonsModal from "@components/OrderCancelReasonsModal";
import OrderCancelSuccessModal from "@components/OrderCancelSuccessModal";
import testIds from "@constants/testIds";
import {
  ActivityIndicator,
  BackHandler,
  FlatList,
  Pressable,
  ScrollView,
  StyleSheet,
  TouchableNativeFeedback,
  View,
} from "react-native";
import { useDispatch, useSelector } from "react-redux";
import ExclaimSymbol from "@assets/svg/ExclaimSymbol";
import ToastMessage from "@components/Toast";
import { MY_ORDERS_EVENTS } from "@constants/analyticsEventsCT";
import colors from "@constants/color";
// eslint-disable-next-line import/no-named-as-default
import t from "@constants/localization";
import metrics from "@constants/metrics";
import useFocusAndAppState from "@hooks/useFocusAndAppState";
import analytics from "@services/analytics";
import { fontFamily } from "@utils/styles";
import debounce from "lodash/debounce";
import BackArrow from "../../assets/svg/BackArrow";
import OrderStatus from "../../assets/svg/OrderStatus";
import { actions as miscActions } from "../../reducers/miscReducer";
import { actions } from "../../reducers/orderReducer";
import { actions as rrdActions } from "../../reducers/rrdReducer";

import {
  cancelOrder,
  getOrderDetailByIdV2,
  getRvpOrderDetails,
  returnRequestCancelV2,
} from "../../services/api";
import CustomModal from "../OrdersList/CustomModal";
import SeeReturnModal from "./SeeReturnModal";

const PATH = "screens/OrderDetails/index";

const COLORS = {
  white: "white",
  black: "black",
  itemBorderBottom: "rgba(0,0,0,0.05)",
  dividerBg: "rgba(0, 0, 0, 0.1)",
  statusTextColor56: "rgba(0, 0, 0, 0.56)",
  statusTextColor86: "rgba(0, 0, 0, 0.86)",
  productName: "rgba(0,0,0,0.86)",
  qtyText: "rgba(0, 0, 0, 0.56)",
  disputedTagBg: "rgba(255, 46, 0, 0.10)",
  disputedTagText: "rgba(255, 46, 0, 1)",
  rtoBg: "rgba(255, 46, 0, 0.1)",
  rtoBorder: "#FF2E00",
  rtoText: "#FF2E00",
  cancelOrderText: "#E40046",
  plasticBagBg: "#FFF9E6",
  plasticBagText: "#B45309",
  amountGreen: "#27AE60",
  personalInfoBg: "rgba(0, 0, 0, 0.05)",
  hrBg: "rgba(0, 0, 0, 0.1)",
  itemDividerBg: "rgba(0,0,0,0.1)",
  rtnBtnBg: "white",
  rtnBtnBorder: "rgba(0, 0, 0, 0.2)",
  remainingText: "rgba(0, 0, 0, 0.56)",
};

const OrderItem = ({
  item_list_status = "",
  item_list_status_icon = "",
  item_list_status_color = "",
  items = [],
  edd = null,
  delivered_at = "",
  cancelled_at = "",

  navigateToProductDetails = () => {},
  navigateToSelectedProduct,
  rvpData = [],
  status,
  data,
  cp_db_id,
  setRefetch,
}) => {
  const [visible, setVisible] = useState(false);
  const [seeReturnData, setSeeReturnData] = useState([]);

  function getOrderDetailsMerged() {
    const merged = [];
    items.forEach((item) => {
      const rvpItem = rvpData.find((rvp) => rvp.order_item_id === item.id);
      merged.push({
        ...item,
        has_active_cx_rto: rvpItem?.has_active_cx_rto,
        return_window_days: rvpItem?.return_window_days,
        enable_return: rvpItem?.enable_return,
        return_time_text: rvpItem?.return_time_text,
        replace_time_text: rvpItem?.replace_time_text,
        return_window_expired_text: rvpItem?.return_window_expired_text,
      });
    });
    return merged;
  }

  const mergedItems = useMemo(() => {
    return getOrderDetailsMerged(items, rvpData);
  }, [items, rvpData]);

  const datePrefix = edd
    ? t(`${PATH}/deliveryDate`)
    : delivered_at
      ? t(`${PATH}/delivered`)
      : cancelled_at
        ? t(`${PATH}/cancellationDate`)
        : "";
  const date = edd || delivered_at || cancelled_at || "";

  const seeReturn = ({ returnRequests }) => {
    setSeeReturnData(returnRequests);
    setVisible(true);
  };

  const shouldShowReturnDekhein = (item) => {
    const singleRvpData = rvpData.find((rvp) => rvp.order_item_id === item.id);
    return (
      (Array.isArray(item?.returnRequests) &&
        item?.returnRequests.length &&
        (status === "RETURNED" || !singleRvpData?.enable_return)) ||
      false
    );
  };

  return (
    <View style={styles.orderItemContainer}>
      <View style={styles.statusRow}>
        <View style={styles.statusLeft}>
          <OrderStatus
            orderStatus={
              data?.cx_rto_details?.agg_status_icon || item_list_status_icon
            }
            testID={testIds.order_satus}
          />
          <Text
            variant="body_text_4"
            style={[
              styles.statusText,
              {
                color:
                  data?.cx_rto_details?.cx_rto_status_color ||
                  item_list_status_color,
              },
            ]}
          >
            {data?.cx_rto_details?.cx_rto_status_text || item_list_status}
          </Text>
        </View>
        {!data?.cx_rto_details?.cx_rto_status_text ? (
          <View style={styles.dateContainer}>
            <Text style={styles.datePrefixText}>
              {datePrefix} <Text style={styles.dateValueText}>{date}</Text>
            </Text>
          </View>
        ) : null}
      </View>
      <View style={styles.divider} />
      <View style={styles.itemsContainer}>
        {mergedItems.map((i, _index) => (
          <Pressable
            onPress={() => navigateToProductDetails(i.slug)}
            key={`key-${i.text}-${i.name}-${_index}`}
            testID={`${testIds.product_no_}${_index}`}
          >
            <View style={styles.productRow}>
              <Image
                source={{ uri: i.product_image ? i.product_image : "" }}
                resizeMode={Image.resizeMode.contain}
                style={styles.productImage}
              />
              <View style={styles.productDetails}>
                <View style={styles.productNameRow}>
                  <Text
                    ellipsizeMode="tail"
                    numberOfLines={1}
                    variant="body_text_3"
                    style={styles.productName}
                  >
                    {i.name}
                  </Text>
                </View>
                <View style={styles.qtyRow}>
                  <Text style={styles.qtyText}>
                    Qty: <Text style={styles.qtyValue}>{i.quantity}</Text>
                  </Text>
                </View>
                {i.disputed_tags && Array.isArray(i.disputed_tags) ? (
                  <View style={styles.disputedTagsContainer}>
                    {i.disputed_tags.map((tag, _idx) => {
                      return (
                        <View key={tag} style={styles.disputedTag}>
                          <Text
                            variant="caption_2"
                            style={styles.disputedTagText}
                          >
                            {tag}
                          </Text>
                        </View>
                      );
                    })}
                  </View>
                ) : null}
                <View style={styles.actionsRow}>
                  {data?.cx_rto_details ? (
                    <View style={styles.rtoContainer}>
                      <Text style={styles.rtoText}>रिटर्न</Text>
                    </View>
                  ) : null}
                  {i.enable_return && !cp_db_id ? (
                    <>
                      <View style={styles.returnActionColumn}>
                        <Pressable
                          onPress={() =>
                            navigateToSelectedProduct(
                              rvpData.find((rvp) => rvp.order_item_id === i.id),
                            )
                          }
                          style={styles.rtnBtnCon}
                        >
                          <Text style={styles.rtnTxt}>रिटर्न</Text>
                        </Pressable>
                        {i.return_time_text || i.replace_time_text ? (
                          <View style={styles.remainingTextContainer}>
                            <ExclaimSymbol fill="rgba(0, 0, 0, 0.36)" />
                            <Text style={styles.remainingText}>
                              {i.return_time_text || i.replace_time_text}
                            </Text>
                          </View>
                        ) : null}
                      </View>
                    </>
                  ) : null}
                  {shouldShowReturnDekhein(i) ? (
                    <>
                      <View style={styles.returnActionColumn}>
                        <Pressable
                          onPress={() =>
                            seeReturn({ returnRequests: i?.returnRequests })
                          }
                          style={styles.rtnBtnCon}
                        >
                          <Text style={styles.rtnTxt}>रिटर्न देखें </Text>
                        </Pressable>
                      </View>
                    </>
                  ) : null}
                </View>
              </View>
            </View>
            {i.return_window_expired_text && status !== "RETURNED" ? (
              <View style={styles.expiredReturnRow}>
                <ExclaimSymbol fill="rgba(0, 0, 0, 0.36)" />
                <Text style={styles.remainingText}>
                  {i.return_window_expired_text}{" "}
                </Text>
              </View>
            ) : null}
            <View style={styles.itemDivider} />
          </Pressable>
        ))}
      </View>
      <SeeReturnModal
        visible={visible}
        setVisible={setVisible}
        setRefetch={setRefetch}
        data={seeReturnData}
      />
    </View>
  );
};

const OrderDetails = ({ route }) => {
  const { params = {} } = route;
  const {
    goBackScreenName = "",
    order_id = "",
    fromDeclarationSubmit = false,
  } = params;
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const [data, setData] = useState({});
  const [rvpDetails, setrvpDetails] = useState([]);
  const [refetch, setRefetch] = useState(false);
  const [cancelModal, setCancelModal] = useState(false);
  const {
    selectedOrder = null,
    cancellationReasons = [],
    isVacationOrder = false,
    source = "FORWARD",
  } = useSelector((s) => s.orders);
  const { cp_db_id = "" } = useSelector((s) => s.auth.user);

  const { toggleOrderDetailsRefetch } = useSelector((s) => s.misc);
  const [reasonsModalVisible, setReasonsModalVisible] = useState(false);
  const [selectedReasonIndex, setSelectedReasonIndex] = useState(null);
  const [hasOrderCancelled, setHasOrderCancelled] = useState(false);
  const [fetchComplete, setFetchComplete] = useState(false);
  const isFocused = useIsFocused();

  useEffect(() => {
    if (isFocused && fromDeclarationSubmit) {
      setRefetch((r) => !r);
    }
  }, [isFocused]);

  const navigateToProductDetails = (slug) => {
    navigation.navigate("ProductDetails", { slug });
  };

  const backhandler = useCallback(() => {
    if (goBackScreenName) {
      navigation.navigate(goBackScreenName);
    } else {
      navigation.goBack();
    }
    return true;
  }, [goBackScreenName, navigation]);

  const onCancelOrder = () => {
    const payload = {
      orderId: data.order_id,
      cancellationReason: selectedReasonIndex,
    };
    cancelOrder(payload)
      .then(({ data: cancelledOrderData }) => {
        setHasOrderCancelled(!!cancelledOrderData.cancelled);
        setReasonsModalVisible(false);
        setSelectedReasonIndex(null);
        setRefetch((r) => !r);
        dispatch(miscActions.showOrderCancelSuccessModal());
        analytics.trackEvent(MY_ORDERS_EVENTS.ORDER_CANCEL, {
          order_id: data?.order_id || "",
        });
      })
      // eslint-disable-next-line no-console
      .catch((error) => console.log(error));
  };
  const cancelReturnRequest = async () => {
    try {
      const { data: res } = await returnRequestCancelV2({
        return_req_id: data?.cx_rto_details?.return_req_id,
        type: data?.cx_rto_details?.type ?? "cx_rto",
      });
      dispatch(rrdActions.fetchRRDInfo());
      setFetchComplete(false);
      setRefetch((r) => !r);
      ToastMessage("success", res?.message);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    }
  };

  useEffect(() => {
    const backHandlerSub = BackHandler.addEventListener("hardwareBackPress", backhandler);
    return () => {
      backHandlerSub.remove();
    };
  }, [backhandler]);

  const fetchOrderData = useCallback(
    debounce(async () => {
      try {
        const { data: response } = await getOrderDetailByIdV2({
          orderId: order_id || selectedOrder,
          isVacationOrder,
          source,
        });
        const orderId = order_id || selectedOrder;
        const { data: rvpData } = await getRvpOrderDetails(orderId);
        dispatch(actions.fetchCancellationReasonsRequest());
        setData(response);
        setFetchComplete(true);

        const rvpDataFilter = rvpData?.items?.filter(
          // eslint-disable-next-line eqeqeq
          (rvp) => rvp.parent_order == orderId,
        );

        if (Array.isArray(rvpDataFilter) && rvpDataFilter.length) {
          setrvpDetails({
            cx_delivery: rvpData.cx_delivery,
            items: rvpDataFilter,
          });
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      }
    }, 500),
    [selectedOrder, dispatch, order_id, refetch, toggleOrderDetailsRefetch],
  );

  useFocusAndAppState(fetchOrderData, fetchOrderData);

  const navigateToSelectedProduct = (rvpData) => {
    navigation.navigate("SelectProduct", {
      rvpData,
    });
  };

  const renderItem = ({ item }) => (
    <OrderItem
      {...item}
      rvpData={rvpDetails?.items}
      key={item.order_id}
      navigateToProductDetails={navigateToProductDetails}
      navigateToSelectedProduct={navigateToSelectedProduct}
      data={data}
      cp_db_id={cp_db_id}
      setRefetch={setRefetch}
    />
  );

  const arrayItems = data?.cx_rto_details
    ? data?.refundDetails
    : data?.priceDetails;

  const renderHeaderComponent = useCallback(() => {
    return (
      <ScrollView testID={testIds.order_scroll_view}>
        <View style={styles.orderSummary}>
          <View style={styles.topContainer}>
            <View style={styles.orderIdContainer}>
              <Text variant="body_text_3" style={styles.orderLabelText}>
                {t(`${PATH}/orderNo`)}
              </Text>
              <Text style={styles.orderIdText}>{data?.order_id ?? ""}</Text>
            </View>
            <View style={styles.orderDateContainer}>
              <Text variant="body_text_3" style={styles.orderLabelText}>
                {t(`${PATH}/orderDate`)}
              </Text>
              <Text variant="body_text_3" style={styles.orderDateText}>
                {` ${data?.created_at.trim() ?? ""}`}
              </Text>
            </View>
          </View>
          <View style={styles.personalInfoWrapper}>
            <View style={styles.personalInfo}>
              <View style={styles.nameRow}>
                <Text variant="subtitle_16">{data?.user_name ?? ""}</Text>
              </View>

              <Text variant="caption_2" style={styles.phone}>
                +91 - {data?.user_phone ?? ""}
              </Text>
              {data?.user_address && (
                <Text variant="caption_2" style={styles.address}>
                  {data?.user_address ?? ""}
                </Text>
              )}
            </View>
          </View>

          {data?.plastic_bag_opted_in &&
            data?.priceDetails?.plasticBagCount > 0 && (
              <View style={styles.plasticBagBanner}>
                <Text variant="body_text_2" style={styles.plasticBagText}>
                  {`${data.priceDetails.plasticBagCount} पॉली बैग ज़रूरी। कृपया इस ऑर्डर को पॉली बैग में डिलीवर करें।`}
                </Text>
              </View>
            )}
          <View style={styles.hr} />
          <View style={styles.priceDetails} testId={testIds.price_detail}>
            <Text variant="subtitle_16" style={styles.priceDetailsHeader}>
              {t(`${PATH}/priceDetails`)}
            </Text>
            {arrayItems &&
              arrayItems.map((i) => (
                <View style={styles.priceRow} key={`${i.amount}${i.text}`}>
                  <Text
                    style={
                      i.bold ? styles.priceTextBold : styles.priceTextRegular
                    }
                  >
                    {i?.text?.trim() || ""}
                  </Text>
                  <Text
                    style={[
                      i.bold || i.amount.trim() === "FREE"
                        ? styles.priceAmountBold
                        : styles.priceAmountRegular,
                      {
                        color: i.amountGreen
                          ? COLORS.amountGreen
                          : colors.black,
                      },
                    ]}
                  >
                    {i?.amount?.trim() || ""}
                  </Text>
                </View>
              ))}
            {data?.show_refundable_amount ? (
              <Text style={styles.refundableAmountText}>
                <Text style={styles.refundableAmountBold}>
                  ₹{data.refundable_amount}
                </Text>{" "}
                {t(`${PATH}/willBeRefunded`)}
              </Text>
            ) : null}
          </View>
        </View>
      </ScrollView>
    );
  }, [data, rvpDetails, arrayItems]);

  return !fetchComplete ? (
    <View style={styles.loadingContainer}>
      <ActivityIndicator />
    </View>
  ) : (
    <View style={styles.rootContainer}>
      <View style={styles.header}>
        <TouchableNativeFeedback
          style={styles.backButton}
          onPress={backhandler}
        >
          <BackArrow style={styles.backArrow} />
        </TouchableNativeFeedback>
        <View style={styles.headerContent}>
          <CustomModal
            heading={
              data?.cx_rto_details?.cancel_confirmation_modal_info?.heading
            }
            visible={cancelModal}
            fontFamily={false}
            headingFontWeight="bold"
            onPress={cancelReturnRequest}
            message={
              data?.cx_rto_details?.cancel_confirmation_modal_info?.message
            }
            setShowModal={() => {
              setCancelModal(false);
            }}
            buttons={
              data?.cx_rto_details?.cancel_confirmation_modal_info
                ?.cancel_confirm_options
            }
          />
          <Text variant="title_18" style={styles.headerTitle}>
            {`${t(`${PATH}/order`)} - ${data?.order_id ?? ""}`}
          </Text>
          {data?.cancellable ? (
            <TouchableNativeFeedback
              onPress={() => {
                setReasonsModalVisible(true);
              }}
              style={styles.cancelOrderButton}
            >
              <Text variant="body_text_4" style={styles.cancelOrderText}>
                {t(`${PATH}/cancelOrder`)}
              </Text>
            </TouchableNativeFeedback>
          ) : (
            <></>
          )}
        </View>
      </View>
      <FlatList
        data={data?.itemLists}
        keyExtractor={(_item, index) => index.toString()}
        ListHeaderComponent={renderHeaderComponent}
        renderItem={renderItem}
      />
      <OrderCancelReasonsModal
        shouldShowModal={reasonsModalVisible}
        handleModalClose={() => setReasonsModalVisible(false)}
        reasons={cancellationReasons}
        setSelectedReason={(reason) => {
          setSelectedReasonIndex(reason);
        }}
        selectedReasonIndex={selectedReasonIndex}
        onCancelOrder={onCancelOrder}
        fromScreen="OrderDetails"
      />
      <OrderCancelSuccessModal
        hasOrderCancelled={hasOrderCancelled}
        fromScreen="OrderDetails"
        cancellationReason={selectedReasonIndex}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  header: {
    backgroundColor: COLORS.white,
    flexDirection: "row",
    minHeight: 56,
    elevation: 1,
  },
  orderSummary: {
    flexDirection: "column",
    paddingTop: 20,
    backgroundColor: COLORS.white,
  },
  topContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingHorizontal: 15,
  },
  orderIdContainer: {
    flex: 1,
  },
  orderLabelText: {
    marginBottom: 4,
  },
  orderIdText: {
    fontWeight: "bold",
    color: COLORS.black,
  },
  orderDateContainer: {
    alignItems: "flex-end",
  },
  orderDateText: {
    color: COLORS.black,
  },
  personalInfoWrapper: {
    paddingHorizontal: 15,
  },
  personalInfo: {
    backgroundColor: COLORS.personalInfoBg,
    padding: 10,
    borderRadius: 10,
    marginTop: 20,
  },
  nameRow: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  phone: {
    color: colors.lightBlack,
  },
  address: {
    opacity: 0.86,
    paddingTop: 2,
  },
  hr: {
    width: "120%",
    height: 1,
    backgroundColor: COLORS.hrBg,
    marginTop: 12,
    marginLeft: -15,
  },
  priceDetails: {
    paddingHorizontal: 15,
  },
  priceDetailsHeader: {
    marginTop: 15,
  },
  priceRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginVertical: 3,
  },
  plasticBagBanner: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    backgroundColor: COLORS.plasticBagBg,
    marginHorizontal: 16,
    borderRadius: 6,
    marginBottom: 8,
  },
  plasticBagText: {
    color: COLORS.plasticBagText,
  },
  refundableAmountText: {
    color: colors.lightBlack,
    paddingVertical: 10,
  },
  refundableAmountBold: {
    fontWeight: "bold",
  },
  loadingContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  rootContainer: {
    flex: 1,
  },
  backButton: {
    paddingRight: 15,
    paddingVertical: 10,
    marginLeft: 10,
  },
  backArrow: {
    margin: 20,
  },
  headerContent: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    flex: 1,
  },
  headerTitle: {
    color: colors.mediumBlack,
    alignSelf: "center",
    marginRight: "auto",
    fontFamily: "NotoSansDevanagari-SemiBold",
    marginTop: 4,
    maxWidth: "70%",
  },
  cancelOrderButton: {
    marginLeft: "auto",
  },
  cancelOrderText: {
    alignSelf: "center",
    color: COLORS.cancelOrderText,
    paddingVertical: 10,
    paddingRight: 15,
  },
  // OrderItem styles
  orderItemContainer: {
    backgroundColor: COLORS.white,
    borderBottomColor: COLORS.itemBorderBottom,
  },
  statusRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 15,
    marginVertical: 5,
    alignItems: "center",
    paddingVertical: 5,
  },
  statusLeft: {
    flexDirection: "row",
  },
  statusText: {
    marginLeft: 6,
    marginTop: 1,
  },
  dateContainer: {
    alignItems: "flex-end",
    justifyContent: "center",
  },
  datePrefixText: {
    color: COLORS.statusTextColor56,
    fontFamily: "NotoSansDevanagari-Regular",
    fontSize: 12,
    lineHeight: 16,
    marginTop: 2,
  },
  dateValueText: {
    color: COLORS.statusTextColor86,
    fontFamily: "NotoSansDevanagari-Bold",
  },
  divider: {
    backgroundColor: COLORS.dividerBg,
    height: 1,
    marginHorizontal: 15,
  },
  itemsContainer: {
    paddingHorizontal: 15,
  },
  productRow: {
    paddingVertical: 15,
    flexDirection: "row",
  },
  productImage: {
    height: 100,
    width: 100,
    marginRight: 10,
  },
  productDetails: {
    flex: 1,
  },
  productNameRow: {
    flexDirection: "row",
  },
  productName: {
    marginBottom: 8,
    color: COLORS.productName,
    flex: 1,
    flexWrap: "wrap",
  },
  qtyRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  qtyText: {
    fontSize: 12,
    lineHeight: 16,
    fontFamily: "NotoSansDevanagari-Regular",
    color: COLORS.qtyText,
  },
  qtyValue: {
    color: COLORS.black,
  },
  disputedTagsContainer: {
    alignItems: "flex-start",
    justifyContent: "flex-start",
  },
  disputedTag: {
    backgroundColor: COLORS.disputedTagBg,
    borderRadius: 20,
    paddingHorizontal: 8,
    paddingVertical: 2,
    marginVertical: 4,
    marginRight: 4,
  },
  disputedTagText: {
    color: COLORS.disputedTagText,
    lineHeight: 18,
  },
  actionsRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 10,
    alignItems: "center",
  },
  rtoContainer: {
    backgroundColor: COLORS.rtoBg,
    paddingTop: 6,
    paddingHorizontal: 30,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 4,
    borderColor: COLORS.rtoBorder,
    borderWidth: 1,
  },
  rtoText: {
    color: COLORS.rtoText,
  },
  returnActionColumn: {
    flexDirection: "column",
    alignItems: "flex-end",
  },
  expiredReturnRow: {
    flexDirection: "row",
    marginBottom: 10,
  },
  itemDivider: {
    borderBottomColor: COLORS.itemDividerBg,
    borderBottomWidth: 1,
    width: metrics.screenWidth,
    marginLeft: -15,
  },
  remainingText: {
    color: COLORS.remainingText,
    marginLeft: 5,
    marginRight: 2,
    fontStyle: "italic",
  },
  remainingTextContainer: {
    flexDirection: "row",
    marginTop: 7,
  },
  rtnBtnCon: {
    width: 95,
    height: 30,
    backgroundColor: COLORS.rtnBtnBg,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: COLORS.rtnBtnBorder,
    justifyContent: "center",
    alignItems: "center",
  },
  rtnTxt: {
    fontSize: 12,
    fontFamily: fontFamily.semiBold,
  },
  priceTextBold: {
    fontFamily: "NotoSansDevanagari-Bold",
    fontSize: 14,
    opacity: 0.86,
  },
  priceTextRegular: {
    fontFamily: "NotoSansDevanagari-Regular",
    fontSize: 14,
    opacity: 0.86,
  },
  priceAmountBold: {
    fontFamily: "NotoSansDevanagari-Bold",
    fontSize: 14,
  },
  priceAmountRegular: {
    fontFamily: "NotoSansDevanagari-Regular",
    fontSize: 14,
  },
});

export default OrderDetails;
